var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSeal = function SvgSeal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55.657,
    height: 16.561,
    viewBox: "0 0 55.657 16.561",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 8.24) scale(34.65434)",
    spreadMethod: "pad",
    id: "prefix__a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff322f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#ff322f",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#e85d95",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#e85d95",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#ffce00",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffce00",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -0.011,
    y1: -0.035,
    x2: 1.011,
    y2: 0.035,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(176.077 27.42 4.807) scale(33.73229)",
    spreadMethod: "pad",
    id: "prefix__b"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4752be",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#4752be",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#42bbfc",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#42bbfc",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#3cb678",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3cb678",
    stopOpacity: 1
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__a)",
    fillOpacity: 1,
    fillRule: "evenodd",
    stroke: "none",
    d: "M15.725 4.992c-3.223-3.526-9.937-3.98-12.477.417a5.744 5.744 0 002.1 7.84 5.728 5.728 0 004.355.575c2.414-.648 4.7-3.792 6.456-5.693l4.075-4.41C22.208 1.58 24.437.109 26.93.006c3.23-.132 6.436 2.037 7.724 4.97-1.576-1.958-4.396-2.955-6.872-2.835-2.763.132-4.446 1.826-6.45 3.996L18.97 8.696l-2.415 2.613c-1.853 2.005-3.428 4.137-6.216 4.885-2.723.73-5.3.012-7.199-1.515C1.326 13.219.13 11.024.01 8.645-.289 2.643 5.892-1.541 11.34.702a8.181 8.181 0 014.385 4.29"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#prefix__b)",
    fillOpacity: 1,
    fillRule: "evenodd",
    stroke: "none",
    d: "M39.932 11.57c3.223 3.526 9.937 3.98 12.477-.417a5.741 5.741 0 00-6.456-8.413c-2.413.647-4.699 3.79-6.455 5.693l-4.075 4.41c-1.974 2.136-4.204 3.61-6.696 3.712-3.23.133-6.436-2.036-7.724-4.97 1.576 1.958 4.397 2.956 6.872 2.837 2.763-.134 4.446-1.828 6.45-3.997l2.363-2.558L39.1 5.254c1.854-2.006 3.43-4.14 6.217-4.885 2.723-.73 5.3-.012 7.2 1.514 1.813 1.458 3.01 3.655 3.13 6.034.3 6.002-5.883 10.187-11.33 7.943a8.168 8.168 0 01-4.386-4.29"
  })));
};
export default SvgSeal;